export default __webpack_public_path__ + "static/media/7A2_CL1633.58535669.png";